import { useAppContext } from "@/contexts/AppContext";
import { useEffect } from "react";

type PageTitleProps = {
    title: string;
};

export const PageTitle = (props: PageTitleProps) => {
    const { title } = useAppContext();

    useEffect(() => {
        let pageTitle = title;

        if (props.title && props.title !== "") {
            pageTitle = `${props.title} | ${title}`;
        }

        document.title = pageTitle;
    }, [title, props.title]);

    return <></>;
};

export const SetPageTitle = (title: string) => {
    if (title === undefined) {
        return;
    }
    document.title = title;
};
